import React from "react";
import "./accessoriesMain.style.sass";
import productData from "../../data/products/products.json";
import { AddProduct } from "../../redux/users/users.actions";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectAccessory } from "../../redux/users/users.selector";
import HeaderPage from "../../assets/image/SingleProductHeader.png";
import { SetProduct } from "../../redux/site/site.actions";
import Accessories from "../accessories/accessories.component";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";

const AccessoriesMain = ({ addProduct, productItem, setProduct, history }) => {
	const HandleClick = (item) => {
		setProduct(item);
	};
	return (
		<div className="productsMain">
			<SubHeaderComponent
				imageSrc={HeaderPage}
				pageName="لوازم جانبی زیتونیکس"
			/>
			<div className="productMain-container">
				<Accessories sub={true} />
			</div>
		</div>
	);
};

const mapDispatchToProps = (dispatch) => ({
	addProduct: (product) => dispatch(AddProduct(product)),
	setProduct: (product) => dispatch(SetProduct(product)),
});
const mapStateToProps = createStructuredSelector({
	productItem: selectAccessory,
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessoriesMain);
